import axios from 'axios';

interface Label {
    id: number;
    firstLabel: string;
    secondLabel: string;
    labelType: number;
    createTime: number;
}

export async function getFansStarLabels() {
    const { labels } = await axios.get<never, { labels: Label[] }>(
        '/rest/dsp/tool/labels/fansStar'
    );
    const list = Array.from(new Set(labels.map((item) => item.firstLabel)))
        .map((item, index) => ({
            label: item,
            value: index,
        }))
        .map((item) => ({
            ...item,
            children: labels
                .filter((childItem) => childItem.firstLabel === item.label)
                .map((item) => ({
                    label: item.secondLabel,
                    value: item.id,
                    checkable: true,
                    fullLabel: `${item.firstLabel}-${item.secondLabel}`,
                })),
        }));
    return list;
}

export async function getAppInterestLabels() {
    const { labels } = await axios.get<never, { labels: Label[] }>('/rest/dsp/tool/labels/mobile');
    return labels.map((l) => l.secondLabel);
}

export async function getAppNames(appActionType: number) {
    const { labels } = await axios.post<
        never,
        {
            labels: {
                id: number;
                appActionType: number;
                appDimensionType: number;
                appCategoryName: string;
                status: string;
                createTime: number;
            }[];
        }
    >('/rest/dsp/tool/labels/mobile/appName', { appActionType });
    return labels.map((l) => ({ label: l.appCategoryName, isChecked: false }));
}

// 获取购物意图标签接口
export async function getIndustryIntension() {
    const { industry } = await axios.post<never, any>('/rest/dsp/tool/labels/purchase_intention');
    return industry;
}

export async function getCategoryBehavior() {
    const { industry } = await axios.post<never, any>('/rest/dsp/tool/labels/category_behavior');
    return industry;
}
// 获取快手小店接口
export async function getIndustrySmallShop() {
    const { industry } = await axios.post<never, any>('/rest/dsp/control-panel/industry/smallShop');
    return industry;
}

export interface AdDmpSecFollowFeverItem {
    label: string;
    value: string;
    children: AdDmpSecFollowFeverItem | null;
    id: number;
    fansNum: number;
    type: string;
}
export async function getSearchLabels(keyword: string) {
    const { labels } = await axios.post<never, { labels: AdDmpSecFollowFeverItem[] }>(
        '/rest/dsp/tool/labels/mmu_follow_fever/search_authors',
        { keyword }
    );
    return labels;
}
